import React from "react";
import { useRouteMatch, Switch, Redirect } from "react-router-dom";
import { DefaultLayout } from "../DefaultLayout";
import { PrivateRoute } from "../../auth/PrivateRoute";
import { OperationsList } from "./Operations";
import { VisualInspectionPage } from "../../testCommunication/visualInspection/VisualInspectionPage";
import { WetLeakagePage } from "../../testCommunication/wetLeakage/WetLeakagePage";
import { DiodeTestPage } from "../../testCommunication/diodeTest/DiodeTestPage";
import { ColorTestPage } from "../../testCommunication/colorimeter/ColorTestPage";
import { Intake } from "../../intake/IntakeRoutes";
import { NewAsset } from "../../projectManagement/components/asset/newAsset";
import { AssetManagement } from "../../projectManagement/components/asset/assetManagement";
import { AssetManagementEdit } from "../../projectManagement/components/asset/assetManagementEdit";
import { LinkedSubAsset } from "../../projectManagement/components/asset/LinkedSubAsset";
import { RevokeAssetTable } from "../../projectManagement/components/asset/revokeAssetTable";

export const Assets = () => {
  const { path } = useRouteMatch();

  return (
    <DefaultLayout>
      <Switch>
       <PrivateRoute exact path={`${path}`} component={AssetManagement} />
        <PrivateRoute exact path={`${path}/new_asset`} component={NewAsset} />
         <PrivateRoute exact path={`${path}/Link_asset`} component={LinkedSubAsset} />
         <PrivateRoute exact path={`${path}/revoke_asset`} component={RevokeAssetTable} />
        <PrivateRoute exact path={`${path}/:asset_id`} component={AssetManagementEdit} />
      </Switch>
    </DefaultLayout>
  );
};
